<script setup lang="ts">
import DynamicStageMvp from './DynamicStageMvp.vue';
import { STAGE_ERROR_MESSAGE_AUTHOR } from '@dh-io-owpi/shared/src/stage/utils/constants';

defineProps<{ error: any }>();
</script>
<template>
  <DynamicStageMvp :errors="[{ mode: 'error', message: STAGE_ERROR_MESSAGE_AUTHOR }]"></DynamicStageMvp>
</template>
